import { React, useEffect } from "react";
import { BrowserRouter, Link, Route, Switch } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";
import GoogleOneTapLogin from "./components/Authentication/GoogleOneTap.jsx";
import AppRoutes from "./Router/Routes.jsx";
import { checkVersion } from "./Utils/CheckVersion.jsx"; // Import the function
import { initializeGoogleTag } from "./Utils/GoogleTag.jsx";
import PostAuthPersonaHandler from "./components/Authentication/PostAuthPersonaHandler.jsx"; // Add this import
import OnboardingWizard from "./components/Authentication/OnboardingWizard.jsx";

const App = () => {
  const trackingID = process.env.REACT_APP_GOOGLE_ANALYTICS_ID;
  const googleClientID = process.env.REACT_APP_GOOGLE_CLIENT_ID;

  useEffect(() => {
    initializeGoogleTag(trackingID); // Initialize Google Analytics
    checkVersion(); // Check for updates on app load
  }, []);

  return (
    <GoogleOAuthProvider
      clientId={googleClientID}
      onScriptLoadError={() => console.error("Google script failed to load")}
      onScriptLoadSuccess={() =>
        console.log("Google script loaded successfully")
      }
    >
      <GoogleOneTapLogin
        clientId={googleClientID}
        onSuccess={(credential) => console.log(credential)}
        onError={(error) => console.error(error)}
      />
      <PostAuthPersonaHandler /> {/* Add this component */}
      <OnboardingWizard />
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </GoogleOAuthProvider>
  );
};

export default App;